import { render, staticRenderFns } from "./MyBonus.vue?vue&type=template&id=3372767f"
import script from "./MyBonus.vue?vue&type=script&lang=js"
export * from "./MyBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3MobileTitleAlert: require('/app/components/Theme3/Mobile/TitleAlert.vue').default,Theme3ComponentsClaimPromoCode: require('/app/components/Theme3/Components/ClaimPromoCode.vue').default,CommonsBonusCardLoading: require('/app/components/Commons/BonusCardLoading.vue').default,CommonsNoBonusCard: require('/app/components/Commons/NoBonusCard.vue').default,CommonsBonusCard: require('/app/components/Commons/BonusCard.vue').default,Theme3ComponentsActiveBonusLoading: require('/app/components/Theme3/Components/ActiveBonusLoading.vue').default,Theme3ComponentsNoActiveBonus: require('/app/components/Theme3/Components/NoActiveBonus.vue').default,Theme3ComponentsEndedBonus: require('/app/components/Theme3/Components/EndedBonus.vue').default,CommonsPromotionHistoryCard: require('/app/components/Commons/PromotionHistoryCard.vue').default})
